import { render, staticRenderFns } from "./EnterOtp.vue?vue&type=template&id=1d70bfb0&"
import script from "./EnterOtp.vue?vue&type=script&lang=js&"
export * from "./EnterOtp.vue?vue&type=script&lang=js&"
import style0 from "./EnterOtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports